<app-info-modal title="Preço Mínimo">
    <div class="eu-display_flex eu-column pricing-modal-body">
        <div>
            <p class="emd-text _size_section _color_default">
                Esta funcionalidade consiste em ter um preço mínimo para que o Líder Comercial da
                Parceria precise aprovar.
            </p>
        </div>
        <div>
            <p class="emd-text _size_section _color_default">
                Caso esteja desabilitado todos os preços irão para aprovação. Quando habilitado,
                deverá ser definido o piso para que esse preço suba para aprovação.
            </p>
        </div>
    </div>
</app-info-modal>
